import { Badge, Tooltip, type BadgeProps } from '@frontend/legacy-components';

// Variants
export const ALPHA_VARIANT = 'alpha';
export const PRIVATE_VARIANT = 'privateBeta';
export const PUBLIC_VARIANT = 'publicBeta';

type FeatureReleaseBadgeVariant =
  | typeof ALPHA_VARIANT
  | typeof PRIVATE_VARIANT
  | typeof PUBLIC_VARIANT;

const BADGE_PROPS: Record<
  'borderColor' | 'color' | 'text' | 'labelText',
  { [key in FeatureReleaseBadgeVariant]: string }
> = {
  borderColor: {
    [ALPHA_VARIANT]: 'featureReleaseStatus.privateBeta',
    [PRIVATE_VARIANT]: 'featureReleaseStatus.privateBeta',
    [PUBLIC_VARIANT]: 'featureReleaseStatus.publicBeta',
  },
  color: {
    [ALPHA_VARIANT]: 'featureReleaseStatus.privateBeta',
    [PRIVATE_VARIANT]: 'featureReleaseStatus.privateBeta',
    [PUBLIC_VARIANT]: 'featureReleaseStatus.publicBeta',
  },
  text: {
    [ALPHA_VARIANT]: 'Alpha',
    [PRIVATE_VARIANT]: 'Private Beta',
    [PUBLIC_VARIANT]: 'Beta',
  },
  labelText: {
    [ALPHA_VARIANT]:
      "This is an experimental feature in early development, please share any feedback on it with the Paperless Parts' team.",
    [PRIVATE_VARIANT]:
      'This feature is being tested with a select group of users. You may see changes as we collect feedback and continue to improve it.',
    [PUBLIC_VARIANT]:
      'This feature is in active development. You may see changes as we collect feedback and continue to improve it.',
  },
};

export type FeatureReleaseStatusBadgeProps = Omit<BadgeProps, 'variant'> & {
  variant?: FeatureReleaseBadgeVariant;
};

/**
 * FeatureReleaseStatusBadge is a Badge that indicates the status of a feature.
 */
export const FeatureReleaseStatusBadge = (
  props: FeatureReleaseStatusBadgeProps,
) => {
  const { variant = PUBLIC_VARIANT, ...badgeProps } = props;
  return (
    <Tooltip
      hasArrow
      label={BADGE_PROPS.labelText[variant]}
      placement="bottom"
      variant="compact"
    >
      <Badge
        borderColor={BADGE_PROPS.borderColor[variant]}
        color={BADGE_PROPS.color[variant]}
        variant="outline"
        {...badgeProps}
      >
        {BADGE_PROPS.text[variant]}
      </Badge>
    </Tooltip>
  );
};
